/**
 * Strategic Direction Lesson
 * Skill Area: Communication
 * Align every message with mission impact
 */

import type { LessonDefinition } from '../types';
import { STRATEGIC_DIRECTION_AI_PROMPT, STRATEGIC_DIRECTION_CONTEXT_SCENARIOS } from '../prompts/strategic-direction.prompt';

export const strategicDirection: LessonDefinition = {
  id: 'strategic-direction',
  title: 'Strategic Direction',
  displayTitle: 'Align Every Message with Mission Impact',
  subTitle: 'Align communications with mission goals',
  persona: 'Lyra',
  skillArea: 'Communication',
  topicId: 'communication-quality',
  topicTitle: 'Communication Quality & Voice',
  topicDescription: 'Verify outputs, keep your voice authentic, and build reusable comms systems.',
  format: 'scenario',
  difficulty: 'Intermediate',
  estimatedMinutes: 7,
  tags: ['strategy', 'alignment', 'mission'],
  dailyEligible: true,
  releasedAt: '2025-01-18T00:00:00.000Z',
  route: '/micro/strategic-direction',
  storyBeat: 'Ensure every message serves your mission.',
  introPrompt: "Your messages sound busy but don't move the needle. That's because you're communicating without a strategy—you've got tactics without purpose. Let's transform that.",
  steps: [
    "Share a communication goal that feels vague",
    "Understand the three alignment layers",
    "See your goal transformed into strategic clarity",
    "Get the template to align any future message"
  ],
  promptGuidance: 'Choose a goal below or describe your own.',
  contextScenarios: STRATEGIC_DIRECTION_CONTEXT_SCENARIOS,
  aiPrompt: STRATEGIC_DIRECTION_AI_PROMPT,
  inputPlaceholder: "e.g., 'We need to communicate more about our impact...'",
  quickPrompts: [
    'Increase donations',
    'Recruit volunteers',
    'Raise awareness',
    'Engage the board'
  ]
};
